<mat-dialog-content>
  <div class="border-b-d1d8d9 max-w-400">
    <div class="pt-24 px-16 pb-16">
      <p class="text-20 leading-24 semibold c-1e2725 m-0">
        {{ data?.title }}
      </p>
      <p class="text-xs leading-15 thin c-primary m-0 mt-4">
        {{ data?.description }}
      </p>
    </div>
  </div>
  <div class="p-16 flex justify-end">
    <div class="flex items-center gap-10">
      <button
      mat-flat-button
      mat-dialog-close
      class="rounded-8 p-12 bg-gray-300 text-black"
      tabindex="-1"
      (click)="_cancel()"
      style="background-color: #d1d5db !important; color: black !important;"
    >
      Annuller
    </button>

      <button
        mat-flat-button
        color="primary"
        class="rounded-8 p-12"
        tabindex="-1"
        (click)="_continue()"
      >
        {{ "Forlad" }}
      </button>
    </div>
  </div>
</mat-dialog-content>
